import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './Progress.module.scss'

export interface ProgressProps {
  center?: boolean
  className?: string
  color?: 'grey' | 'primary' | 'white'
  size?: 'x-small' | 'small' | 'large'
}

export const Progress: FC<ProgressProps> = ({ center, className, color, size = 'x-small' }) => (
  <div className={clsx(
    className,
    styles.progressRoot,
    size && styles[size],
    color && styles[color],
    center && styles.centered,
  )}
  />
)
